import { GET_MORE_OUTPUT_LIST, GET_OUTPUT_LIST } from "./Download.action";

const initialReducer = {
  outPutList: [],
};

export const downloadReducer = (state = initialReducer, action) => {
  switch (action.type) {
    case GET_OUTPUT_LIST:
      return { ...state, outPutList: action.value };
    case GET_MORE_OUTPUT_LIST:
      return { ...state, outPutList: [...state.outPutList, ...action.value] };
    default:
      return state;
  }
};
